<template>
    <div class="flex-level">
        <div class="ellipsis search-result-item gray-100">
            <span>{{ data.name }}</span>
        </div>
        <div v-if="data.address" class="ellipsis search-result-item ml-2 gray-60">
            <span>{{ data.address }}</span>
        </div>
        <div class="ml-2">
            <tag-rounded
                :label="tagsHuman[data.type].label"
                :color="tagsHuman[data.type].color"
                :bgcolor="tagsHuman[data.type].bgcolor"
                class="mr-1"
            >
            </tag-rounded>
        </div>
        <div v-if="data.corpid" class="ml-2">
            <tag-rounded :label="thirdCorpid" color="grey-60" bgcolor="gray-05" class="mr-1">
            </tag-rounded>
        </div>
        <div v-if="data.link" class="flex-right"><i class="icon-chevron-right gray-60"></i></div>
    </div>
</template>

<script>
import TagHumansConfig from 'Config/authenticated/TagHumans';
import TagRounded from 'vcomponents/utilities/TagRounded.vue';

export default {
    components: {
        TagRounded,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        tagsHuman() {
            return TagHumansConfig;
        },
        thirdCorpid() {
            return 'Sellsy #' + this.data.corpid;
        },
    },
};
</script>
